import { render, staticRenderFns } from "./ImportJobRestoreSetupWizard.vue?vue&type=template&id=61c5f190&"
import script from "./ImportJobRestoreSetupWizard.vue?vue&type=script&lang=ts&"
export * from "./ImportJobRestoreSetupWizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VAlert,VAutocomplete,VBtn,VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VIcon,VProgressLinear,VRow,VStepper,VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c5f190')) {
      api.createRecord('61c5f190', component.options)
    } else {
      api.reload('61c5f190', component.options)
    }
    module.hot.accept("./ImportJobRestoreSetupWizard.vue?vue&type=template&id=61c5f190&", function () {
      api.rerender('61c5f190', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/import/ImportJobRestoreSetupWizard.vue"
export default component.exports